function _userAgentContains (value: string): boolean {
  return navigator.userAgent.indexOf(value) !== -1;
}

function isChrome (): boolean {
  return _userAgentContains('Chrome');
}

function isFirefox (): boolean {
  return _userAgentContains('Firefox');
}

function isSafari (): boolean {
  return _userAgentContains('Safari') && _userAgentContains('Chrome');
}

function isInternetExplorer (): boolean {
  return _userAgentContains('MSIE');
}

function isInternetExplorer64 (): boolean {
  return isInternetExplorer() && _userAgentContains('Win64');
}

function isInternetExplorer32 (): boolean {
  return isInternetExplorer() && !isInternetExplorer64();
}

function isEdge (): boolean {
  return _userAgentContains('Edge');
}

function isEdge64 (): boolean {
  return isEdge() && _userAgentContains('Win64');
}

function isEdge32 (): boolean {
  return isEdge() && !isEdge64();
}

function isMac (): boolean {
  return _userAgentContains('Mac');
}

function _isMajorMacVersion (major: number): boolean {
  return isMac() && (_userAgentContains(' ' + major + '_') || _userAgentContains(' ' + major + '.'));
}

function _isMacVersion (major: number, minor: number): boolean {
  return isMac() && (_userAgentContains(' ' + major + '_' + minor) || _userAgentContains(' ' + major + '.' + minor));
}

function isMacOSXLeopard () {
  return _isMacVersion(10, 5);
}

function isMacOSXSnowLeopard (): boolean {
  return _isMacVersion(10, 6);
}

function isMacOSXLion (): boolean {
  return _isMacVersion(10, 7);
}

function isMacOSXMountainLion (): boolean {
  return _isMacVersion(10, 8);
}

function isMacOSXMavericks (): boolean {
  return _isMacVersion(10, 9);
}

function isMacOSXYosemite (): boolean {
  return _isMacVersion(10, 10);
}

function isMacOSXElCapitan (): boolean {
  return _isMacVersion(10, 11);
}

function isMacOSSierra (): boolean {
  return _isMacVersion(10, 12);
}

function isMacOSHighSierra (): boolean {
  return _isMacVersion(10, 13);
}

function isMacOSMojave (): boolean {
  return _isMacVersion(10, 14);
}

function isMacOSCatalina (): boolean {
  return _isMacVersion(10, 15);
}

function isMacOSBigSur (): boolean {
  return _isMajorMacVersion(11) || _isMacVersion(10, 16);
}

function isWindows () {
  return _userAgentContains('Win');
}

function isWindows32 () {
  return isWindows() && !isWindows64();
}

function isWindows64 () {
  return isWindows() && (_userAgentContains('WOW64') || _userAgentContains('Win64'));
}

function isWindowsXP () {
  return _userAgentContains('NT 5.1') || _userAgentContains('NT 5.2');
}

function isWindowsVista () {
  return _userAgentContains('NT 6.0');
}

function isWindows7 () {
  return _userAgentContains('NT 6.1');
}

function isWindows8 () {
  return _userAgentContains('NT 6.2');
}

function isWindows81 () {
  return _userAgentContains('NT 6.3');
}

function isWindows10 () {
  return _userAgentContains('NT 10.0');
}

function getClientBrowser () {
  if (isEdge64()) {
    return 'Microsoft Edge (64-bit)';
  } else if (isEdge32()) {
    return 'Microsoft Edge (32-bit)';
  } else if (isChrome()) {
    return 'Google Chrome';
  } else if (isFirefox()) {
    return 'Mozilla Firefox';
  } else if (isSafari()) {
    return 'Apple Safari';
  } else if (isInternetExplorer64()) {
    return 'Microsoft Internet Explorer (64-bit)';
  } else if (isInternetExplorer32()) {
    return 'Microsoft Internet Explorer (32-bit)';
  }
  return 'Other';
}

function getClientOS () {
  if (isMac()) {
    if (isMacOSBigSur()) {
      return 'macOS Big Sur 11';
    } else if (isMacOSCatalina()) {
      return 'macOS Catalina 10.15 or higher'; // Safari and Firefox currently use 10.15.6 and 10.15 respectively for Big Sur,
                                               // so no way to detect if it is Big Sur or Catalina
    } else if (isMacOSMojave()) {
      return 'macOS Mojave 10.14';
    } else if (isMacOSHighSierra()) {
      return 'macOS High Sierra 10.13';
    } else if (isMacOSSierra()) {
      return 'macOS Sierra 10.12';
    } else if (isMacOSXElCapitan()) {
      return 'OS X El Capitan 10.11';
    } else if (isMacOSXYosemite()) {
      return 'OS X Yosemite 10.10';
    } else if (isMacOSXMavericks()) {
      return 'OS X Mavericks 10.9';
    } else if (isMacOSXMountainLion()) {
      return 'OS X Mountain Lion 10.8';
    } else if (isMacOSXLion()) {
      return 'Mac OS X Lion 10.7';
    } else if (isMacOSXSnowLeopard()) {
      return 'Mac OS X Snow Leopard 10.6';
    } else if (isMacOSXLeopard()) {
      return 'Mac OS X Leopard 10.5';
    } else {
      return 'macOS';
    }
  } else if (isWindows()) {
    return 'Windows';
  }
  return 'Other';
}

const Client = {
  isChrome,
  isFirefox,
  isSafari,
  isInternetExplorer,
  isInternetExplorer64,
  isInternetExplorer32,
  isEdge,
  isEdge64,
  isEdge32,
  isMac,
  isMacOSXLeopard,
  isMacOSXSnowLeopard,
  isMacOSXLion,
  isMacOSXMountainLion,
  isMacOSXMavericks,
  isMacOSXYosemite,
  isMacOSXElCapitan,
  isMacOSSierra,
  isMacOSHighSierra,
  isMacOSMojave,
  isMacOSCatalina,
  isMacOSBigSur,
  isWindows,
  isWindows32,
  isWindows64,
  isWindowsXP,
  isWindowsVista,
  isWindows7,
  isWindows8,
  isWindows81,
  isWindows10,
  getClientBrowser,
  getClientOS
};

export {
  isMac
};

export default Client;
